export const columnsBranch = [
    {
      Header: "ID",
      accessor: row => `${row.id || ''}`,
    },
    {
      Header: "LIST",
      accessor: row => `${row.name_branch || ''} ${row.menu_name || ''}`,
    },
    {
      Header: "SELECT",
      accessor: "id",
    }
  ];
  